import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { HeaderFeature } from '@app/src/common/header';
import { FooterFeature } from '@app/src/common/footer';
import { ListPackageFeature } from '@app/src/views/Package/listPackage';
import { setUserPasarella } from '@app/src/common/session';

export const Package: React.FC = () => {

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setUserPasarella('purchase-package'));
  }, []);

  return (
    <React.Fragment>
      <HeaderFeature />
      <ListPackageFeature />
      <FooterFeature isDisplay={true} />
    </React.Fragment>
  )
};
